 
import { Home } from "../Modules/Home/Home";
import { Overview } from "../Modules/Home/Overview";

import  Customerorder  from "../Modules/Customerorder";
import  JobOrder  from "../Modules/Job/JobOrder";
import  Tracker  from "../Modules/Job/Tracker";
import  CustomerMaster  from "../Modules/Masters/CustomerMaster";
import LocationMaster from "../Modules/Masters/LocationMaster";
import  BankMaster  from "../Modules/Masters/BankMaster";
import { ProductMaster } from "../Modules/Masters/ProductMaster";
import  NCRCodeMaster  from "../Modules/Masters/NCRCodeMaster";
import  WorkstationMaster  from "../Modules/Masters/WorkstationMaster";
import  PartTemplate  from "../Modules/Settings/PartTemplate";
import  Documents  from "../Modules/Settings/Documents";
import { User } from "../Modules/UserManagement/User";
import { RolePermission } from "../Modules/UserManagement/RolePermission";
import  VendorOrder  from "../Modules/Purchasing/VendorOrder";
import { VendorReceiving } from "../Modules/Purchasing/VendorReceiving";
import  Receivable  from "../Modules/Accounts/Receivable";
import { InvoiceApproval } from "../Modules/Purchasing/InvoiceApproval";
import  InvoiceList  from "../Modules/Purchasing/InvoiceList";
import  InvoicePayment  from "../Modules/Purchasing/InvoicePayment";
import VendorMaster from "../Modules/Masters/VendorMaster";
import  DocumentMaster  from "../Modules/Masters/DocumentMaster";
import  Quotations  from "../Modules/Quotations";
import  ProcessMaster  from "../Modules/Masters/ProcessMaster";
import PriceBreakdownMaster from "../Modules/Masters/PriceBreakdownMaster";
import  Register  from "../Modules/Accounts/Register";
import { NCRReport } from "../Modules/Reports/NCRReport";
import  NCR  from "../Modules/Job/NCR";
import { SearchAll } from "../Modules/SearchAll";
import  Reports  from "../Modules/Reports/Reports";
import {Drilldown} from "../Modules/Reports/Drilldown";
import {Vendor} from "../Modules/Vendor";
import  COAMaster from "../Modules/Masters/COAMaster";
import  LaborTimesheets  from "../Modules/LaborTimesheets";
import { Component } from "react";
import { VendorInbox } from "../Modules/Purchasing/VendorInbox";
import { InvoiceInbox } from "../Modules/Accounts/InvoiceInbox";
import { DraftInbox } from "../Modules/Accounts/DraftInbox";
import  Journal  from "../Modules/Accounts/Journal";
import  Invoice  from "../Modules/Accounts/Invoice";
import  Reconcile  from "../Modules/Accounts/Reconcile";
import  VendorQuotations  from "../Modules/Purchasing/VendorQuotations";
import ImportPayroll from "../Modules/ImportPayroll";
import BucketMaster from "../Modules/Masters/BucketMaster";
import CreditCardMaster from "../Modules/Masters/CreditCardMaster";
import { ReportDrill } from "../Modules/Reports/ReportDrill";
import AccountingPeriod from "../Modules/Accounts/AccountingPeriod";
import BankSync from "../Modules/Accounts/BankSync";
// Dashboard imports
import AirframeDashboard from "../Modules/Dashboard/AirframeDashboard";
import DashboardAnalytics from "../Modules/Dashboard/pages/Analytics";
import DashboardOrders from "../Modules/Dashboard/pages/Orders";
import DashboardCustomers from "../Modules/Dashboard/pages/Customers";
import DashboardInventory from "../Modules/Dashboard/pages/Inventory";
import DashboardReportCenter from "../Modules/Dashboard/pages/Reports";
import DashboardSettings from "../Modules/Dashboard/pages/Settings";
export const protectedRoutes = [
 
  
  {
    path: "/overview",
    name: "Overview",
    Component: Overview,
  },

  {
    path: "/home",
    name: "Dashboard",
    Component: AirframeDashboard,
  },
  
  {
    path: "/customerorder",
    name: "Customerorder",
    Component: Customerorder,
  },

  {
    path: "/customermaster",
    name: "CustomerMaster",
    Component: CustomerMaster,
  },
  {
    path: "/bankmaster",
    name: "BankMaster",
    Component: BankMaster,
  },
  {
    path: "/JobOrder",
    name: "JobOrder",
    Component: JobOrder,
  },
  {
    path: "/productmaster",
    name: "ProductMaster",
    Component: ProductMaster,
  },
  {
    path: "/NCRCodeMaster",
    name: "NCRCodeMaster",
    Component: NCRCodeMaster,
  },
  {
    path: "/workstationmaster",
    name: "WorkstationMaster",
    Component: WorkstationMaster,
  },  
  {
    path: "/parttemplate",
    name: "PartTemplate",
    Component: PartTemplate,
  },
  {
    path: "/documents",
    name: "Documents",
    Component: Documents,
  }
  ,
  {
    path: "/User",
    name: "User",
    Component: User,
  },
  {
    path: "/RolePermission",
    name: "Role Permission",
    Component: RolePermission,
  },
  {
    path: "/VendorOrder",
    name: "VendorOrder",
    Component: VendorOrder,
  },
  {
    path: "/Quotations",
    name: "Quotations",
    Component: Quotations,
  },
  {
    path: "/VendorReceiving",
    name: "VendorReceiving",
    Component: VendorReceiving,
  },
  {
    path: "/Tracker",
    name: "Tracker",
    Component: Tracker,
  }
  ,
  {
    path: "/Receivable",
    name: "Receivable",
    Component: Receivable,
  }
  ,
  {
    path: "/InvoiceList",
    name: "InvoiceList",
    Component: InvoiceList,
  } ,
  {
    path: "/InvoicePayment",
    name: "InvoicePayment",
    Component: InvoicePayment,
  }
  ,
  {
    path: "/InvoiceApproval",
    name: "InvoiceApproval",
    Component: InvoiceApproval,
  }
  ,
  {
    path: "/VendorMaster",
    name: "VendorMaster",
    Component: VendorMaster,
  }
  ,
  {
    path: "/ProcessMaster",
    name: "ProcessMaster",
    Component: ProcessMaster,
  },
  {
    path: "/COAMaster",
    name: "COAMaster",
    Component: COAMaster,
  }
  ,
  {
    path: "/PriceBreakdown",
    name: "PriceBreakdown",
    Component: PriceBreakdownMaster,
  },
  {
    path: "/Register",
    name: "Register",
    Component: Register,
  }
  ,
  {
    path: "/NCRReport",
    name: "NCRReport",
    Component: NCRReport,
  }
  ,
  {
    path: "/NCR",
    name: "NCR",
    Component: NCR,
  },
  {
    path: "/Reports",
    name: "Reports",
    Component: Reports,
  },
  {
    path: "/Drilldown",
    name: "Drilldown",
    Component: Drilldown,
  },
  {
    path: "/SearchAll",
    name: "SearchAll",
    Component: SearchAll,
  },
  {
    path: "/timesheet",
    name: "timesheet",
    Component: LaborTimesheets,
  }
  ,
  {
    path: "/vendorinbox",
    name: "vendorinbox",
    Component: VendorInbox,
  },
  {
    path: "/invoiceinbox",
    name: "invoiceinbox",
    Component: InvoiceInbox,
  },
  {
    path: "/draftinbox",
    name: "draftinbox",
    Component: DraftInbox,
  },
  {
    path: "/Journal",
    name: "journal",
    Component: Journal,
  },
  {
    path: "/Invoices",
    name: "invoices",
    Component: Invoice,
  },
  {
    path: "/Reconcile",
    name: "reconcilation",
    Component: Reconcile,
  },
  {
    path: "/VendorQuotations",
    name: "VendorQuotations",
    Component: VendorQuotations,
  },
  {
    path: "/LocationMaster",
    name: "LocationMaster",
    Component: LocationMaster,
  },
  {
    path: "/ImportPayroll",
    name: "ImportPayroll",
    Component: ImportPayroll,
  },
   {
    path: "/BankSync",
    name: "BankSync",
    Component: BankSync,
  },
    {
    path: "/AccountingPeriod",
    name: "AccountingPeriod",
    Component: AccountingPeriod,
  },
  // Dashboard routes
  {
    path: "/dashboard",
    name: "Business Analytics",
    Component: AirframeDashboard,
  },
  {
    path: "/analytics",
    name: "Data Insights",
    Component: DashboardAnalytics,
  },
  {
    path: "/orders",
    name: "Order Management",
    Component: DashboardOrders,
  },
  {
    path: "/customers",
    name: "Customer Database",
    Component: DashboardCustomers,
  },
  {
    path: "/inventory",
    name: "Stock Management",
    Component: DashboardInventory,
  },
  {
    path: "/reports",
    name: "Report Center",
    Component: DashboardReportCenter,
  },
  {
    path: "/settings",
    name: "System Settings",
    Component: DashboardSettings,
  },
   {
    path: "/DocumentMaster",
    name: "Document Master",
    Component: DocumentMaster,
  },
  {
    path: "/BucketMaster",
    name: "Bucket Master",
    Component: BucketMaster,
  },
   {
    path: "/CreditCardMaster",
    name: "Credit Card Master",
    Component: CreditCardMaster,
  }
];

